const resolveMaxWidth = maxWidth => {
  return maxWidth === 'anchorWidth' ? {} : {
    maxWidth
  };
};
const resolveMinWidth = minWidth => {
  return minWidth === 'anchorWidth' ? {} : {
    minWidth
  };
};
export const listBoxPaperDefaultStyle = (theme, maxHeight, maxWidth, minWidth) => ({
  maxHeight: maxHeight ?? 'none',
  ...resolveMaxWidth(maxWidth),
  ...resolveMinWidth(minWidth),
  overflow: 'auto',
  boxShadow: theme.tokens.BaseShadowMd,
  border: `${theme.tokens.ComponentListBoxDividerBorderColor} solid 1px`,
  borderRadius: '4px',
  // cursor: displaySpinner && 'not-allowed',

  '&.MuiDivider-root': {
    borderColor: theme.tokens.ComponentListBoxDividerBorderColor
  }
});
export const resolveIconFontSize = (size, theme) => {
  const map = {
    small: '12px',
    sm: '12px',
    medium: '14px',
    md: '14px',
    large: '16px',
    lg: '16px'
  };
  return map[size];
};
export const resolveFontSize = (size, theme) => {
  const map = {
    small: theme.tokens.ComponentListBoxItemFontSizeSmall,
    sm: theme.tokens.ComponentListBoxItemFontSizeSmall,
    medium: theme.tokens.ComponentListBoxItemFontSizeMedium,
    md: theme.tokens.ComponentListBoxItemFontSizeMedium,
    large: theme.tokens.ComponentListBoxItemFontSizeLarge,
    lg: theme.tokens.ComponentListBoxItemFontSizeLarge
  };
  return map[size];
};
const resolveLineHeight = (size, theme) => {
  const map = {
    small: theme.tokens.ComponentListBoxItemLineHeightSmall,
    sm: theme.tokens.ComponentListBoxItemLineHeightSmall,
    medium: theme.tokens.ComponentListBoxItemLineHeightMedium,
    md: theme.tokens.ComponentListBoxItemLineHeightMedium,
    large: theme.tokens.ComponentListBoxItemLineHeightLarge,
    lg: theme.tokens.ComponentListBoxItemLineHeightLarge
  };
  return map[size];
};
const paddingMap = {
  small: '7px 12px',
  sm: '7px 12px',
  medium: '10px 12px',
  md: '10px 12px',
  large: '12px',
  lg: '12px'
};
export const listBoxItemDefaultStyle = (theme, size) => ({
  padding: theme.tokens.ComponentListBoxItemPadding,
  background: theme.tokens.ComponentListBoxItemBg,
  '&:hover, &.Mui-selected:hover, &.Mui-focusVisible:hover': {
    background: theme.tokens.ComponentListBoxItemHoverBg
  },
  '&.Mui-focusVisible': {
    background: theme.tokens.ComponentListBoxItemFocusBg
  },
  '&:active, &.Mui-selected, &.Mui-selected.Mui-focusVisible': {
    background: theme.tokens.SemColorSurfaceDefault,
    '&:active': {
      background: theme.tokens.ComponentListBoxItemActiveBg
    }
  },
  '&.MuiMenuItem-root': {
    color: theme.tokens.ComponentListBoxItemColor,
    fontWeight: theme.tokens.ComponentListBoxItemFontWeight,
    lineHeight: resolveLineHeight(size, theme),
    fontSize: resolveFontSize(size, theme),
    fontFamily: theme.tokens.ComponentListBoxItemFontFamily,
    fontFeatureSettings: `"clig" off, "liga"`,
    padding: paddingMap[size]
  },
  '&.Mui-disabled': {
    color: theme.tokens.ComponentListBoxItemDisabledColor,
    opacity: '1',
    cursor: theme.tokens.ComponentListBoxItemDisabledCursor,
    pointerEvents: 'none'
  }
});
const resolveGroupHeaderFontSize = (size, theme) => {
  const map = {
    small: theme.tokens.ComponentListBoxGroupNameFontSizeSmall,
    sm: theme.tokens.ComponentListBoxGroupNameFontSizeSmall,
    medium: theme.tokens.ComponentListBoxGroupNameFontSizeMedium,
    md: theme.tokens.ComponentListBoxGroupNameFontSizeMedium,
    large: theme.tokens.ComponentListBoxGroupNameFontSizeLarge,
    lg: theme.tokens.ComponentListBoxGroupNameFontSizeLarge
  };
  return map[size];
};
export const listBoxGroupNameDefaultStyle = (theme, size) => ({
  '&.MuiMenuItem-root': {
    padding: '8px 8px 0 8px',
    cursor: 'default',
    color: theme.tokens.ComponentListBoxGroupNameColor,
    fontSize: resolveGroupHeaderFontSize(size, theme),
    fontWeight: theme.tokens.ComponentListBoxGroupNameFontWeight,
    lineHeight: theme.tokens.ComponentListBoxGroupNameLineHeight,
    fontFamily: theme.tokens.ComponentListBoxGroupNameFontFamily,
    backgroundColor: theme.tokens.ComponentListBoxBackgroundColor
  },
  '&:hover, &.Mui-selected:hover, &.Mui-focusVisible:hover': {
    background: theme.tokens.ComponentListBoxBackgroundColor
  },
  '&.Mui-focusVisible': {
    background: theme.tokens.ComponentListBoxBackgroundColor
  },
  '&:active, &.Mui-selected, &.Mui-selected.Mui-focusVisible': {
    background: theme.tokens.ComponentListBoxBackgroundColor,
    '&:active': {
      background: theme.tokens.ComponentListBoxBackgroundColor
    }
  }
});
export const popperStyles = {
  zIndex: '99999'
};